import { type RowClassParams } from "ag-grid-community";
import { ListIllustration } from "vega-illustrations";

import { type LimitedPartnerFundBreakdown } from "@vega-api/generated/types/limitedPartnerFundBreakdown";
import { type LimitedPartnerFundBreakdownTotals } from "@vega-api/generated/types/limitedPartnerFundBreakdownTotals";
import {
  DataGrid,
  DATAGRID_TOTAL_ROW_CLASS,
} from "@vega-core/components/DataGrid/DataGrid";
import { m } from "@vega-core/paraglide/messages";

import {
  type FundBreakdownGridRow,
  useFundBreakdownColumns,
} from "../../hooks/useFundBreakdownColumns";

const getRowClass = ({ node }: RowClassParams<FundBreakdownGridRow>) =>
  node.rowPinned ? DATAGRID_TOTAL_ROW_CLASS : undefined;

type FundBreakdownTableProps = {
  fundBreakdown: LimitedPartnerFundBreakdown[];
  fundBreakdownTotals?: LimitedPartnerFundBreakdownTotals;
  isLoading?: boolean;
};

export const FundBreakdownTable = ({
  fundBreakdown,
  fundBreakdownTotals,
  isLoading,
}: FundBreakdownTableProps) => {
  const columnDefs = useFundBreakdownColumns();

  const totalsRow: FundBreakdownGridRow[] = fundBreakdownTotals
    ? [{ ...fundBreakdownTotals, fundName: m.common_total() }]
    : [];

  return (
    <div data-testid="fund-breakdown-table">
      <DataGrid<FundBreakdownGridRow>
        columnDefs={columnDefs}
        emptyState={{
          title: m.coInvestments_insights_lpProfile_fundBreakdown_empty(),
          illustration: <ListIllustration />,
        }}
        getRowClass={getRowClass}
        loading={isLoading}
        pinnedBottomRowData={totalsRow}
        rowData={fundBreakdown}
      />
    </div>
  );
};
